import React from "react";
import ReactDOM from "react-dom/client";

// Self-hosted, like Pyodide: one origin, and the type is the same on every
// machine. Geist for the interface, Geist Mono for code and numbers, and
// Instrument Serif only for the display accents on the Guide and Board.
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "@fontsource/instrument-serif/400.css";
import "@fontsource/instrument-serif/400-italic.css";

import { Root } from "./Root";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
